// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-page.finance-page {
  max-width: 960px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 8px;
  padding-top: 12px;
}
.business-page.finance-page > * {
  grid-column: 1/-1;
  min-width: 0;
}
.business-page.finance-page .business-back {
  grid-row: 1;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 6px;
}
.business-page.finance-page > h1 {
  grid-column: 1;
  grid-row: 2;
  align-self: center;
  margin: 0 0 10px;
  font-size: clamp(23px, 4vw, 28px);
  letter-spacing: -0.03em;
}
.business-page.finance-page .business-subtitle {
  display: none;
}
.business-page.finance-page .positive {
  color: #287b5f;
}
.business-page.finance-page .negative {
  color: #b32943;
}
.business-page.finance-page .finance-primary, .business-page.finance-page .finance-secondary, .business-page.finance-page .finance-icon-button, .business-page.finance-page .finance-text-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 8px 12px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.35;
  text-decoration: none;
}
.business-page.finance-page .finance-primary {
  background: #e72f44;
  color: #fff;
}
.business-page.finance-page .finance-secondary {
  background: #edf1f6;
  color: #3e4860;
}
.business-page.finance-page .finance-icon-button {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  padding: 0;
  border: 1px solid #e1e6ef;
  color: #6c7891;
  background: #fff;
}
.business-page.finance-page .finance-text-button {
  padding-inline: 4px;
  color: #65718c;
  background: none;
  font-size: 12px;
}
.business-page.finance-page .finance-header-actions {
  grid-column: 2;
  grid-row: 2;
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}
.business-page.finance-page .finance-learn-button {
  padding-inline: 10px;
  white-space: nowrap;
}
.business-page.finance-page .finance-learn-button svg {
  width: 18px;
  height: 18px;
}
.business-page.finance-page .finance-period {
  margin-bottom: 10px;
}
.business-page.finance-page .finance-period label {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  color: #78849a;
  font-size: 12px;
}
.business-page.finance-page .finance-period input {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  min-height: 44px;
  padding: 8px 10px;
  font-size: 16px;
  box-sizing: border-box;
}
.business-page.finance-page .finance-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 3px;
  padding: 3px;
  border-radius: 12px;
  background: #e9edf4;
  margin-bottom: 12px;
}
.business-page.finance-page .finance-tabs button {
  min-height: 44px;
  padding: 6px 3px;
  font-size: 13px;
  border: none;
  border-radius: 9px;
  color: #6f7b92;
  background: none;
}
.business-page.finance-page .finance-tabs button[aria-selected=true] {
  background: #fff;
  color: #232137;
  font-weight: 650;
  box-shadow: 0 1px 4px rgba(35, 33, 55, 0.0431372549);
}
.business-page.finance-page .finance-card {
  min-width: 0;
  margin-bottom: 10px;
  padding: 14px;
  border: 1px solid #e1e6ef;
  border-radius: 16px;
  background: #fff;
}
.business-page.finance-page .finance-card h2 {
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 1.35;
}
.business-page.finance-page .finance-card p {
  margin: 8px 0;
  font-size: 13px;
  line-height: 1.5;
}
.business-page.finance-page .finance-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.business-page.finance-page .finance-section-heading h2 {
  margin: 0;
  font-size: 15px;
}
.business-page.finance-page .finance-section-heading p {
  margin: 3px 0 0;
  color: #78849a;
  font-size: 11px;
}
.business-page.finance-page .finance-count {
  font-size: 12px;
  color: #78849a;
  font-variant-numeric: tabular-nums;
}
.business-page.finance-page .finance-profit {
  color: #232137;
  box-shadow: 0 3px 14px rgba(35, 33, 55, 0.0117647059);
}
.business-page.finance-page .finance-profit-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  color: #6e7b91;
  font-size: 12px;
}
.business-page.finance-page .finance-confirmed {
  padding: 3px 7px;
  border-radius: 6px;
  background: #f1f3f8;
  font-size: 10px;
  color: #78849a;
}
.business-page.finance-page .finance-profit-value {
  margin: 10px 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.business-page.finance-page .finance-profit-value > strong {
  font-size: clamp(28px, 5vw, 36px);
  line-height: 1.2;
  letter-spacing: -0.035em;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.business-page.finance-page .finance-profit-value > span {
  font-size: 11px;
  color: #78849a;
  display: grid;
  gap: 3px;
}
.business-page.finance-page .finance-profit-value > span b {
  font-size: 16px;
  color: #232137;
  font-variant-numeric: tabular-nums;
}
.business-page.finance-page .finance-profit.positive .finance-profit-value > strong {
  color: #287b5f;
}
.business-page.finance-page .finance-profit.negative .finance-profit-value > strong {
  color: #b32943;
}
.business-page.finance-page .finance-primary-metrics, .business-page.finance-page .finance-secondary-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.business-page.finance-page .finance-primary-metrics > div, .business-page.finance-page .finance-secondary-metrics > div {
  display: grid;
  gap: 5px;
  min-width: 0;
}
.business-page.finance-page .finance-primary-metrics span, .business-page.finance-page .finance-secondary-metrics span {
  color: #78849a;
  font-size: 11px;
  line-height: 1.4;
}
.business-page.finance-page .finance-primary-metrics strong, .business-page.finance-page .finance-primary-metrics b, .business-page.finance-page .finance-secondary-metrics strong, .business-page.finance-page .finance-secondary-metrics b {
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.business-page.finance-page .finance-primary-metrics strong {
  font-size: 19px;
  letter-spacing: -0.025em;
}
.business-page.finance-page .finance-secondary-metrics {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #edf0f5;
}
.business-page.finance-page .finance-secondary-metrics b {
  font-size: 14px;
}
.business-page.finance-page .finance-alert {
  margin: 0 0 10px;
  padding: 10px 12px;
  border-radius: 11px;
  font-size: 12px;
  line-height: 1.5;
}
.business-page.finance-page .finance-alert.warning {
  background: #fff6e8;
  color: #8c673a;
}
.business-page.finance-page .finance-alert.error {
  background: #fff0f2;
  color: #a71b34;
}
.business-page.finance-page .finance-alert.success {
  background: #edf7f1;
  color: #32775b;
}
.business-page.finance-page .finance-card .finance-alert {
  margin: 8px 0 0;
  font-size: 12px;
}
.business-page.finance-page .finance-muted {
  color: #78849a;
  font-size: 12px !important;
  line-height: 1.5;
}
.business-page.finance-page .finance-cash-summary .finance-section-heading {
  margin-bottom: 0;
}
.business-page.finance-page .finance-cash-value {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
}
.business-page.finance-page .finance-cash-value span {
  color: #78849a;
}
.business-page.finance-page .finance-cash-value strong {
  font-size: 21px;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.business-page.finance-page .finance-overview-links, .business-page.finance-page .finance-add-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}
.business-page.finance-page .finance-overview-links > button, .business-page.finance-page .finance-add-actions > button {
  flex: 1 1;
}
.business-page.finance-page .finance-add-actions .finance-primary {
  flex: 1.1 1;
}
.business-page.finance-page .finance-rows-heading {
  display: flex;
  justify-content: space-between;
  color: #78849a;
  font-size: 10px;
  padding: 6px 26px 6px 0;
}
.business-page.finance-page .finance-article {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 64px;
  text-align: left;
  border: none;
  border-top: 1px solid #edf0f5;
  background: #fff;
  padding: 8px 0;
  color: #232137;
}
.business-page.finance-page .finance-article:hover {
  background: #fafbfe;
}
.business-page.finance-page .finance-article > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  color: #7c879c;
}
.business-page.finance-page .finance-article > span {
  min-width: 0;
  display: grid;
  gap: 4px;
}
.business-page.finance-page .finance-article-name {
  flex: 1 1;
}
.business-page.finance-page .finance-article-name strong {
  font-size: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.business-page.finance-page .finance-article-name small {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.business-page.finance-page .finance-article-values {
  max-width: 45%;
  text-align: right;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.business-page.finance-page .finance-article-values small {
  font-size: 11px;
}
.business-page.finance-page .finance-article-values b {
  font-size: 14px;
}
.business-page.finance-page .finance-article.income .finance-article-values b {
  color: #287b5f;
}
.business-page.finance-page .finance-empty {
  color: #78849a;
  padding: 10px 0;
}
.business-page.finance-page .finance-form {
  background: #f7f9fc;
  border: 1px solid #e5e9f1;
  border-radius: 12px;
  padding: 12px;
  margin: 10px 0;
}
.business-page.finance-page .finance-form h3 {
  font-size: 14px;
  margin: 0 0 10px;
}
.business-page.finance-page .finance-form .section-field {
  margin-top: 10px;
}
.business-page.finance-page .finance-form .section-label {
  font-size: 12px;
}
.business-page.finance-page .finance-form .section-btn-secondary, .business-page.finance-page .finance-form .section-upload-remove {
  min-height: 44px;
  font-size: 13px;
}
.business-page.finance-page .finance-form fieldset, .business-page.finance-page .finance-settings fieldset {
  min-width: 0;
  border: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.business-page.finance-page .finance-form label, .business-page.finance-page .finance-settings label {
  min-width: 0;
  font-size: 12px;
  line-height: 1.35;
  gap: 5px;
}
.business-page.finance-page .finance-form input:not([type=checkbox]), .business-page.finance-page .finance-form select, .business-page.finance-page .finance-settings input:not([type=checkbox]), .business-page.finance-page .finance-settings select {
  width: 100%;
  min-height: 44px;
  padding: 8px 9px;
  font-size: 16px;
  box-sizing: border-box;
}
.business-page.finance-page .finance-form input:focus, .business-page.finance-page .finance-form select:focus, .business-page.finance-page .finance-settings input:focus, .business-page.finance-page .finance-settings select:focus {
  outline: 2px solid rgba(231, 47, 68, 0.1882352941);
  border-color: #e72f44;
}
.business-page.finance-page .finance-form .finance-field-wide, .business-page.finance-page .finance-settings .finance-field-wide {
  grid-column: 1/-1;
}
.business-page.finance-page .finance-form-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.business-page.finance-page .finance-form-actions .finance-primary {
  flex: 1 1;
}
.business-page.finance-page .finance-settings fieldset {
  grid-template-columns: minmax(0, 1fr);
}
.business-page.finance-page .finance-checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px !important;
  min-height: 44px;
  padding: 8px 0;
  margin: 6px 0;
  cursor: pointer;
}
.business-page.finance-page .finance-checkbox input {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  min-height: 0;
  padding: 0;
  accent-color: #e72f44;
}
.business-page.finance-page .finance-settings > button {
  width: 100%;
}
.business-page.finance-page .finance-payment {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 0;
  border-top: 1px solid #edf0f5;
}
.business-page.finance-page .finance-payment-info {
  flex: 1 1;
  min-width: 0;
  display: grid;
  gap: 4px;
}
.business-page.finance-page .finance-payment-info > strong {
  font-size: 13px;
  overflow-wrap: anywhere;
}
.business-page.finance-page .finance-payment-info > span {
  font-size: 11px;
  color: #78849a;
  line-height: 1.4;
}
.business-page.finance-page .finance-payment-status {
  font-size: 10px;
  color: #8d7b53;
}
.business-page.finance-page .finance-payment-status.paid {
  color: #287b5f;
}
.business-page.finance-page .finance-payment-status.cancelled {
  color: #8b92a0;
}
.business-page.finance-page .finance-payment-right {
  flex: 0 1 auto;
  max-width: 45%;
  display: grid;
  justify-items: end;
  gap: 4px;
}
.business-page.finance-page .finance-payment-right > b {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
  text-align: right;
}
.business-page.finance-page .finance-payment-actions {
  display: flex;
  gap: 2px;
}
.business-page.finance-page .finance-payment-actions .finance-icon-button {
  border: none;
}
.business-page.finance-page .finance-payment-menu {
  position: relative;
}
.business-page.finance-page .finance-payment-menu > summary {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  cursor: pointer;
  color: #78849a;
  border-radius: 10px;
}
.business-page.finance-page .finance-payment-menu > summary::-webkit-details-marker {
  display: none;
}
.business-page.finance-page .finance-payment-menu > div {
  position: absolute;
  right: 0;
  top: 44px;
  z-index: 8;
  padding: 5px;
  min-width: 205px;
  border: 1px solid #e1e6ef;
  border-radius: 11px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(35, 33, 55, 0.0705882353);
}
.business-page.finance-page .finance-payment-menu > div button {
  min-height: 44px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  color: #a71b34;
  background: #fff3f5;
}
.business-page.finance-page .finance-details > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 44px;
  list-style: none;
  font-size: 13px;
  cursor: pointer;
}
.business-page.finance-page .finance-details > summary::-webkit-details-marker {
  display: none;
}
.business-page.finance-page .finance-details > summary svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #78849a;
}
.business-page.finance-page .finance-details[open] > summary svg {
  transform: rotate(180deg);
}
.business-page.finance-page .finance-card.finance-details {
  padding-block: 0;
}
.business-page.finance-page .finance-files summary {
  min-height: 44px;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 11px;
  color: #78849a;
}
.business-page.finance-page .finance-files a {
  display: flex;
  align-items: center;
  min-height: 44px;
  font-size: 12px;
  color: #65718c;
}
.business-page.finance-page .finance-cash-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  margin-bottom: 8px;
  font-size: 12px;
}
.business-page.finance-page .finance-cash-table th, .business-page.finance-page .finance-cash-table td {
  padding: 9px 5px;
  text-align: right;
  border-top: 1px solid #edf0f5;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.business-page.finance-page .finance-cash-table th {
  font-size: 10px;
  color: #78849a;
  font-weight: 500;
}
.business-page.finance-page .finance-cash-table th:first-child, .business-page.finance-page .finance-cash-table td:first-child {
  width: 44px;
  padding-left: 0;
  text-align: left;
}
.business-page.finance-page .finance-method p {
  font-size: 12px;
  color: #78849a;
  line-height: 1.5;
}
.business-page.finance-page .finance-related {
  display: flex;
  gap: 16px;
}
.business-page.finance-page .finance-related a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  font-size: 12px;
  color: #78849a;
  text-decoration: none;
}
.business-page.finance-page .finance-lesson {
  border: 1px solid #dce4fa;
  border-radius: 14px;
  padding: 12px;
  margin-bottom: 12px;
  background: #f0f4ff;
  color: #374463;
}
.business-page.finance-page .finance-lesson h2 {
  margin: 8px 0 5px;
  font-size: 15px;
}
.business-page.finance-page .finance-lesson > p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
}
.business-page.finance-page .finance-lesson .finance-lesson-safety {
  margin: 5px 0 0;
  font-size: 11px;
  color: #68799a;
}
.business-page.finance-page .finance-lesson progress {
  display: block;
  appearance: none;
  width: 100%;
  height: 4px;
  margin-top: 10px;
  border: 0;
  border-radius: 4px;
  background: #dce4f8;
}
.business-page.finance-page .finance-lesson progress::-webkit-progress-bar {
  background: #dce4f8;
  border-radius: 4px;
}
.business-page.finance-page .finance-lesson progress::-webkit-progress-value {
  background: #7d8ebc;
  border-radius: 4px;
}
.business-page.finance-page .finance-lesson progress::-moz-progress-bar {
  background: #7d8ebc;
  border-radius: 4px;
}
.business-page.finance-page .finance-lesson-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
}
.business-page.finance-page .finance-lesson-meta > span {
  font-weight: 650;
}
.business-page.finance-page .finance-lesson-meta small {
  color: #68799a;
  font-size: 11px;
}
.business-page.finance-page .finance-lesson-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}
.business-page.finance-page .finance-lesson-actions button {
  flex: 1 1 auto;
  font-size: 12px;
  padding-inline: 10px;
}
.business-page.finance-page .business-error {
  margin: 0 0 10px;
  font-size: 13px;
  padding: 12px;
}
.business-page.finance-page .business-error button {
  min-height: 44px;
  padding: 8px 12px;
  margin-left: 8px;
  border: none;
  border-radius: 10px;
  background: #fff;
  font-size: 13px;
  color: #a71b34;
}
@media (max-width: 650px) {
  .business-page.finance-page {
    padding: 10px 10px 24px;
  }
  .business-page.finance-page .finance-card {
    padding-inline: 12px;
  }
  .business-page.finance-page .finance-tabs button {
    font-size: 12px;
  }
  .business-page.finance-page .finance-profit-value > strong {
    font-size: 29px;
  }
  .business-page.finance-page .finance-primary-metrics strong {
    font-size: 18px;
  }
  .business-page.finance-page .finance-secondary-metrics {
    gap: 8px;
  }
  .business-page.finance-page .finance-add-actions {
    gap: 6px;
  }
  .business-page.finance-page .finance-add-actions button {
    font-size: 12px;
    padding-inline: 8px;
  }
  .business-page.finance-page .finance-form {
    padding: 10px;
  }
  .business-page.finance-page .finance-form fieldset {
    gap: 8px;
  }
}

.lkfr-app .business-page.finance-page {
  max-width: 960px;
  margin-inline: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/FinancePage/finance.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;AACF;AAAE;EAAM,iBAAA;EAAqB,YAAA;AAI7B;AAHE;EAAiB,WAAA;EAAa,eAAA;EAAiB,iBAAA;EAAmB,kBAAA;AASpE;AARE;EAAO,cAAA;EAAgB,WAAA;EAAa,kBAAA;EAAoB,gBAAA;EAAkB,iCAAA;EAAmC,uBAAA;AAgB/G;AAfE;EAAqB,aAAA;AAkBvB;AAjBE;EAAY,cAAA;AAoBd;AAnBE;EAAY,cAAA;AAsBd;AArBE;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,gBAAA;EAAkB,iBAAA;EAChG,YAAA;EAAc,mBAAA;EAAqB,eAAA;EAAiB,iBAAA;EAAmB,qBAAA;AAgC3E;AA9BE;EAAmB,mBAAA;EAAqB,WAAA;AAkC1C;AAjCE;EAAqB,mBAAA;EAAqB,cAAA;AAqC5C;AApCE;EAAuB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,UAAA;EAAY,yBAAA;EAA2B,cAAA;EAAgB,gBAAA;AA6C3H;AA5CE;EAAuB,mBAAA;EAAqB,cAAA;EAAgB,gBAAA;EAAkB,eAAA;AAkDhF;AAjDE;EAA0B,cAAA;EAAgB,WAAA;EAAa,aAAA;EAAe,QAAA;EAAU,mBAAA;AAwDlF;AAvDE;EAAwB,oBAAA;EAAsB,mBAAA;AA2DhD;AA3DqE;EAAM,WAAA;EAAa,YAAA;AA+DxF;AA9DE;EAAkB,mBAAA;AAiEpB;AAhEI;EAAQ,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,SAAA;EAAW,cAAA;EAAgB,eAAA;AAwEhG;AAvEI;EAAQ,SAAA;EAAS,YAAA;EAAc,WAAA;EAAa,gBAAA;EAAkB,iBAAA;EAAmB,eAAA;EAAiB,sBAAA;AAgFtG;AA9EE;EAAgB,aAAA;EAAe,gDAAA;EAAkD,QAAA;EAAU,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,mBAAA;AAuFrJ;AAtFI;EAAS,gBAAA;EAAkB,gBAAA;EAAkB,eAAA;EAAiB,YAAA;EAAc,kBAAA;EAAoB,cAAA;EAAgB,gBAAA;AA+FpH;AA9FI;EAA6B,gBAAA;EAAkB,cAAA;EAAgB,gBAAA;EAAkB,oDAAA;AAoGrF;AAlGE;EAAgB,YAAA;EAAc,mBAAA;EAAqB,aAAA;EAAe,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;AA0GpH;AAzGI;EAAK,gBAAA;EAAkB,eAAA;EAAiB,iBAAA;AA8G5C;AA7GI;EAAI,aAAA;EAAe,eAAA;EAAiB,gBAAA;AAkHxC;AAhHE;EAA2B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,mBAAA;AAuH3G;AAtHI;EAAK,SAAA;EAAW,eAAA;AA0HpB;AAzHI;EAAI,eAAA;EAAiB,cAAA;EAAgB,eAAA;AA8HzC;AA5HE;EAAiB,eAAA;EAAiB,cAAA;EAAgB,kCAAA;AAiIpD;AAhIE;EAAkB,cAAA;EAAgB,qDAAA;AAoIpC;AAnIE;EAA0B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,eAAA;EAAiB,QAAA;EAAU,cAAA;EAAgB,eAAA;AA4I3I;AA3IE;EAAqB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,eAAA;EAAiB,cAAA;AAkJnG;AAjJE;EAAwB,mBAAA;EAAqB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,eAAA;EAAiB,QAAA;AAyJpI;AAxJI;EAAW,iCAAA;EAAmC,gBAAA;EAAkB,wBAAA;EAAyB,kCAAA;EAAoC,uBAAA;AA+JjI;AA9JI;EAAS,eAAA;EAAiB,cAAA;EAAgB,aAAA;EAAe,QAAA;AAoK7D;AApKuE;EAAI,eAAA;EAAiB,cAAA;EAAgB,kCAAA;AAyK5G;AAvKE;EAA0D,cAAA;AA0K5D;AAzKE;EAA0D,cAAA;AA4K5D;AA3KE;EAAuD,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAgL1H;AA/KI;EAAQ,aAAA;EAAe,QAAA;EAAU,YAAA;AAoLrC;AAnLI;EAAO,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAwL5C;AAvLI;EAAY,kCAAA;EAAoC,uBAAA;AA2LpD;AAzLE;EAAkC,eAAA;EAAiB,wBAAA;AA6LrD;AA5LE;EAA6B,gBAAA;EAAkB,iBAAA;EAAmB,6BAAA;AAiMpE;AAjMmG;EAAI,eAAA;AAoMvG;AAnME;EAAiB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;AA0M/F;AAzMI;EAAY,mBAAA;EAAqB,cAAA;AA6MrC;AA5MI;EAAU,mBAAA;EAAqB,cAAA;AAgNnC;AA/MI;EAAY,mBAAA;EAAqB,cAAA;AAmNrC;AAjNE;EAA+B,eAAA;EAAiB,eAAA;AAqNlD;AApNE;EAAiB,cAAA;EAAgB,0BAAA;EAA4B,gBAAA;AAyN/D;AAxNE;EAAiD,gBAAA;AA2NnD;AA1NE;EAAsB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,eAAA;AAiOvG;AAhOI;EAAO,cAAA;AAmOX;AAnO6B;EAAS,eAAA;EAAiB,kCAAA;EAAoC,uBAAA;AAwO3F;AAtOE;EAAgD,aAAA;EAAe,QAAA;EAAU,mBAAA;AA2O3E;AA3OgG;EAAW,SAAA;AA8O3G;AA7OyB;EAAmB,WAAA;AAgP5C;AA/OE;EAAwB,aAAA;EAAe,8BAAA;EAAgC,cAAA;EAAgB,eAAA;EAAiB,uBAAA;AAsP1G;AArPE;EAAmB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,WAAA;EAAa,gBAAA;EAAkB,gBAAA;EAAkB,YAAA;EAAc,6BAAA;EAA+B,gBAAA;EAAkB,cAAA;EAAgB,cAAA;AAkQpM;AAjQI;EAAU,mBAAA;AAoQd;AAnQI;EAAQ,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,cAAA;AAyQvD;AAxQI;EAAS,YAAA;EAAc,aAAA;EAAe,QAAA;AA6Q1C;AA3QE;EAAwB,SAAA;AA8Q1B;AA9QmC;EAAS,eAAA;EAAiB,mBAAA;EAAqB,uBAAA;EAAyB,gBAAA;AAoR3G;AApR+H;EAAQ,eAAA;EAAiB,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;AA0R/L;AAzRE;EAA0B,cAAA;EAAgB,iBAAA;EAAmB,kCAAA;EAAoC,uBAAA;AA+RnG;AA/R4H;EAAQ,eAAA;AAkSpI;AAlSuJ;EAAI,eAAA;AAqS3J;AApSE;EAAoD,cAAA;AAuStD;AAtSE;EAAiB,cAAA;EAAgB,eAAA;AA0SnC;AAzSE;EAAgB,mBAAA;EAAqB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,cAAA;AAgTtG;AA/SI;EAAK,eAAA;EAAiB,gBAAA;AAmT1B;AAlTI;EAAiB,gBAAA;AAqTrB;AApTI;EAAiB,eAAA;AAuTrB;AAtTI;EAAiD,gBAAA;EAAkB,eAAA;AA0TvE;AAvTI;EAAW,YAAA;EAAc,YAAA;EAAc,SAAA;EAAW,UAAA;EAAY,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAgUnI;AA/TI;EAAQ,YAAA;EAAc,eAAA;EAAiB,iBAAA;EAAmB,QAAA;AAqU9D;AApUI;EAAqC,WAAA;EAAa,gBAAA;EAAkB,gBAAA;EAAkB,eAAA;EAAiB,sBAAA;AA2U3G;AA1UI;EAA4B,kDAAA;EAA8B,qBAAA;AA8U9D;AA7UI;EAAsB,iBAAA;AAgV1B;AA9UE;EAAwB,aAAA;EAAe,QAAA;EAAU,gBAAA;AAmVnD;AAnVqE;EAAmB,SAAA;AAsVxF;AArVE;EAA6B,qCAAA;AAwV/B;AAvVE;EAAoB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,oBAAA;EAAsB,gBAAA;EAAkB,cAAA;EAAgB,aAAA;EAAe,eAAA;AAiWtJ;AAhWI;EAAQ,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,aAAA;EAAe,UAAA;EAAY,qBAAA;AAwWlF;AAtWE;EAA6B,WAAA;AAyW/B;AAxWE;EAAmB,aAAA;EAAe,uBAAA;EAAyB,8BAAA;EAAgC,SAAA;EAAW,eAAA;EAAiB,6BAAA;AAgXzH;AA/WE;EAAwB,SAAA;EAAS,YAAA;EAAc,aAAA;EAAe,QAAA;AAqXhE;AApXI;EAAW,eAAA;EAAiB,uBAAA;AAwXhC;AAvXI;EAAS,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AA4X9C;AA1XE;EAA0B,eAAA;EAAiB,cAAA;AA8X7C;AA9X6D;EAAS,cAAA;AAiYtE;AAjYwF;EAAc,cAAA;AAoYtG;AAnYE;EAAyB,cAAA;EAAgB,cAAA;EAAgB,aAAA;EAAe,kBAAA;EAAoB,QAAA;AA0Y9F;AAzYI;EAAM,eAAA;EAAiB,kCAAA;EAAoC,uBAAA;EAAyB,iBAAA;AA+YxF;AA7YE;EAA2B,aAAA;EAAe,QAAA;AAiZ5C;AAjZsD;EAAuB,YAAA;AAoZ7E;AAnZE;EAAwB,kBAAA;AAsZ1B;AArZI;EAAY,WAAA;EAAa,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;EAAgB,mBAAA;AAga3J;AAhagL;EAA4B,aAAA;AAma5M;AAlaI;EAAQ,kBAAA;EAAoB,QAAA;EAAU,SAAA;EAAW,UAAA;EAAY,YAAA;EAAc,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;EAAkB,qDAAA;AA8anK;AA7aM;EAAS,gBAAA;EAAkB,WAAA;EAAa,iBAAA;EAAmB,YAAA;EAAc,kBAAA;EAAoB,eAAA;EAAiB,cAAA;EAAgB,mBAAA;AAubpI;AAnbI;EAAY,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,gBAAA;EAAkB,gBAAA;EAAkB,eAAA;EAAiB,eAAA;AA6bnJ;AA7boK;EAA4B,aAAA;AAgchM;AAhciN;EAAM,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,cAAA;AAsclQ;AArcI;EAAwB,yBAAA;AAwc5B;AAtcE;EAAgC,gBAAA;AAyclC;AAxcmB;EAAU,gBAAA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,eAAA;EAAiB,cAAA;AAgdrH;AAhduI;EAAI,aAAA;EAAe,mBAAA;EAAqB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAudlN;AAtdE;EAAsB,WAAA;EAAa,mBAAA;EAAqB,yBAAA;EAA2B,kBAAA;EAAoB,eAAA;AA6dzG;AA5dI;EAAS,gBAAA;EAAkB,iBAAA;EAAmB,6BAAA;EAA+B,kCAAA;EAAoC,uBAAA;AAmerH;AAleI;EAAK,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AAue1C;AAve8D;EAAiC,WAAA;EAAa,eAAA;EAAiB,gBAAA;AA4e7H;AA1eE;EAAoB,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AA+evD;AA9eE;EAAmB,aAAA;EAAe,SAAA;AAkfpC;AAlf+C;EAAI,oBAAA;EAAsB,mBAAA;EAAqB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;EAAgB,qBAAA;AA0fjJ;AAzfE;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,cAAA;AAigB7H;AAhgBI;EAAK,iBAAA;EAAmB,eAAA;AAogB5B;AAngBI;EAAM,SAAA;EAAW,eAAA;EAAiB,gBAAA;AAwgBtC;AAvgBI;EAAyB,eAAA;EAAiB,eAAA;EAAiB,cAAA;AA4gB/D;AA3gBI;EAAW,cAAA;EAAgB,gBAAA;EAAkB,WAAA;EAAa,WAAA;EAAa,gBAAA;EAAkB,SAAA;EAAW,kBAAA;EAAoB,mBAAA;AAqhB5H;AArhBiJ;EAA0B,mBAAA;EAAqB,kBAAA;AAyhBhM;AAzhBsN;EAA4B,mBAAA;EAAqB,kBAAA;AA6hBvQ;AA7hB6R;EAAuB,mBAAA;EAAqB,kBAAA;AAiiBzU;AA/hBE;EAAuB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,eAAA;AAsiBvG;AAtiBwH;EAAS,gBAAA;AAyiBjI;AAziBqJ;EAAQ,cAAA;EAAgB,eAAA;AA6iB7K;AA5iBE;EAA0B,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,gBAAA;AAkjBtE;AAljBwF;EAAS,cAAA;EAAgB,eAAA;EAAiB,oBAAA;AAujBlI;AAtjBE;EAAkB,gBAAA;EAAkB,eAAA;EAAiB,aAAA;AA2jBvD;AA3jBsE;EAAS,gBAAA;EAAkB,iBAAA;EAAmB,gBAAA;EAAkB,YAAA;EAAc,mBAAA;EAAqB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAqkB5M;AApkBE;EACE;IAAI,uBAAA;EAukBN;EAtkBE;IAAgB,oBAAA;EAykBlB;EAxkBE;IAAuB,eAAA;EA2kBzB;EA1kBE;IAAiC,eAAA;EA6kBnC;EA5kBE;IAAkC,eAAA;EA+kBpC;EA9kBE;IAA6B,QAAA;EAilB/B;EAhlBE;IAAuB,QAAA;EAmlBzB;EAnlBmC;IAAS,eAAA;IAAiB,mBAAA;EAulB7D;EAtlBE;IAAgB,aAAA;EAylBlB;EAxlBE;IAAyB,QAAA;EA2lB3B;AACF;;AAzlBA;EAAwC,gBAAA;EAAkB,mBAAA;AA8lB1D","sourcesContent":[".business-page.finance-page {\n  max-width: 960px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  column-gap: 8px;\n  padding-top: 12px;\n  > * { grid-column: 1 / -1; min-width: 0; }\n  .business-back { grid-row: 1; font-size: 12px; line-height: 18px; margin-bottom: 6px; }\n  > h1 { grid-column: 1; grid-row: 2; align-self: center; margin: 0 0 10px; font-size: clamp(23px, 4vw, 28px); letter-spacing: -.03em; }\n  .business-subtitle { display: none; }\n  .positive { color: #287b5f; }\n  .negative { color: #b32943; }\n  .finance-primary, .finance-secondary, .finance-icon-button, .finance-text-button {\n    display: inline-flex; align-items: center; justify-content: center; gap: 6px; min-height: 44px; padding: 8px 12px;\n    border: none; border-radius: 10px; font-size: 13px; line-height: 1.35; text-decoration: none;\n  }\n  .finance-primary { background: #e72f44; color: #fff; }\n  .finance-secondary { background: #edf1f6; color: #3e4860; }\n  .finance-icon-button { width: 44px; height: 44px; flex: 0 0 44px; padding: 0; border: 1px solid #e1e6ef; color: #6c7891; background: #fff; }\n  .finance-text-button { padding-inline: 4px; color: #65718c; background: none; font-size: 12px; }\n  .finance-header-actions { grid-column: 2; grid-row: 2; display: flex; gap: 6px; margin-bottom: 10px; }\n  .finance-learn-button { padding-inline: 10px; white-space: nowrap; svg { width: 18px; height: 18px; } }\n  .finance-period { margin-bottom: 10px;\n    label { display: flex; flex-direction: row; align-items: center; gap: 10px; color: #78849a; font-size: 12px; }\n    input { flex: 1; min-width: 0; width: 100%; min-height: 44px; padding: 8px 10px; font-size: 16px; box-sizing: border-box; }\n  }\n  .finance-tabs { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 3px; padding: 3px; border-radius: 12px; background: #e9edf4; margin-bottom: 12px;\n    button { min-height: 44px; padding: 6px 3px; font-size: 13px; border: none; border-radius: 9px; color: #6f7b92; background: none; }\n    button[aria-selected=true] { background: #fff; color: #232137; font-weight: 650; box-shadow: 0 1px 4px #2321370b; }\n  }\n  .finance-card { min-width: 0; margin-bottom: 10px; padding: 14px; border: 1px solid #e1e6ef; border-radius: 16px; background: #fff;\n    h2 { margin: 0 0 10px; font-size: 16px; line-height: 1.35; }\n    p { margin: 8px 0; font-size: 13px; line-height: 1.5; }\n  }\n  .finance-section-heading { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 10px;\n    h2 { margin: 0; font-size: 15px; }\n    p { margin: 3px 0 0; color: #78849a; font-size: 11px; }\n  }\n  .finance-count { font-size: 12px; color: #78849a; font-variant-numeric: tabular-nums; }\n  .finance-profit { color: #232137; box-shadow: 0 3px 14px #23213703; }\n  .finance-profit-heading { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 6px; color: #6e7b91; font-size: 12px; }\n  .finance-confirmed { padding: 3px 7px; border-radius: 6px; background: #f1f3f8; font-size: 10px; color: #78849a; }\n  .finance-profit-value { margin: 10px 0 16px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px;\n    > strong { font-size: clamp(28px, 5vw, 36px); line-height: 1.2; letter-spacing: -.035em; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }\n    > span { font-size: 11px; color: #78849a; display: grid; gap: 3px; b { font-size: 16px; color: #232137; font-variant-numeric: tabular-nums; } }\n  }\n  .finance-profit.positive .finance-profit-value > strong { color: #287b5f; }\n  .finance-profit.negative .finance-profit-value > strong { color: #b32943; }\n  .finance-primary-metrics, .finance-secondary-metrics { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px;\n    > div { display: grid; gap: 5px; min-width: 0; }\n    span { color: #78849a; font-size: 11px; line-height: 1.4; }\n    strong, b { font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }\n  }\n  .finance-primary-metrics strong { font-size: 19px; letter-spacing: -.025em; }\n  .finance-secondary-metrics { margin-top: 12px; padding-top: 12px; border-top: 1px solid #edf0f5; b { font-size: 14px; } }\n  .finance-alert { margin: 0 0 10px; padding: 10px 12px; border-radius: 11px; font-size: 12px; line-height: 1.5;\n    &.warning { background: #fff6e8; color: #8c673a; }\n    &.error { background: #fff0f2; color: #a71b34; }\n    &.success { background: #edf7f1; color: #32775b; }\n  }\n  .finance-card .finance-alert { margin: 8px 0 0; font-size: 12px; }\n  .finance-muted { color: #78849a; font-size: 12px !important; line-height: 1.5; }\n  .finance-cash-summary .finance-section-heading { margin-bottom: 0; }\n  .finance-cash-value { display: flex; align-items: center; justify-content: space-between; gap: 10px; font-size: 12px;\n    span { color: #78849a; } strong { font-size: 21px; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }\n  }\n  .finance-overview-links, .finance-add-actions { display: flex; gap: 8px; margin-bottom: 10px; > button { flex: 1; } }\n  .finance-add-actions { .finance-primary { flex: 1.1; } }\n  .finance-rows-heading { display: flex; justify-content: space-between; color: #78849a; font-size: 10px; padding: 6px 26px 6px 0; }\n  .finance-article { display: flex; align-items: center; gap: 10px; width: 100%; min-height: 64px; text-align: left; border: none; border-top: 1px solid #edf0f5; background: #fff; padding: 8px 0; color: #232137;\n    &:hover { background: #fafbfe; }\n    > svg { width: 16px; height: 16px; flex: 0 0 16px; color: #7c879c; }\n    > span { min-width: 0; display: grid; gap: 4px; }\n  }\n  .finance-article-name { flex: 1; strong { font-size: 13px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; } small { font-size: 11px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } }\n  .finance-article-values { max-width: 45%; text-align: right; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; small { font-size: 11px; } b { font-size: 14px; } }\n  .finance-article.income .finance-article-values b { color: #287b5f; }\n  .finance-empty { color: #78849a; padding: 10px 0; }\n  .finance-form { background: #f7f9fc; border: 1px solid #e5e9f1; border-radius: 12px; padding: 12px; margin: 10px 0;\n    h3 { font-size: 14px; margin: 0 0 10px; }\n    .section-field { margin-top: 10px; }\n    .section-label { font-size: 12px; }\n    .section-btn-secondary, .section-upload-remove { min-height: 44px; font-size: 13px; }\n  }\n  .finance-form, .finance-settings {\n    fieldset { min-width: 0; border: none; margin: 0; padding: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }\n    label { min-width: 0; font-size: 12px; line-height: 1.35; gap: 5px; }\n    input:not([type=checkbox]), select { width: 100%; min-height: 44px; padding: 8px 9px; font-size: 16px; box-sizing: border-box; }\n    input:focus, select:focus { outline: 2px solid #e72f4430; border-color: #e72f44; }\n    .finance-field-wide { grid-column: 1 / -1; }\n  }\n  .finance-form-actions { display: flex; gap: 8px; margin-top: 12px; .finance-primary { flex: 1; } }\n  .finance-settings fieldset { grid-template-columns: minmax(0, 1fr); }\n  .finance-checkbox { display: flex; flex-direction: row; align-items: center; gap: 10px !important; min-height: 44px; padding: 8px 0; margin: 6px 0; cursor: pointer;\n    input { width: 20px; height: 20px; flex: 0 0 20px; min-height: 0; padding: 0; accent-color: #e72f44; }\n  }\n  .finance-settings > button { width: 100%; }\n  .finance-payment { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; padding: 12px 0; border-top: 1px solid #edf0f5; }\n  .finance-payment-info { flex: 1; min-width: 0; display: grid; gap: 4px;\n    > strong { font-size: 13px; overflow-wrap: anywhere; }\n    > span { font-size: 11px; color: #78849a; line-height: 1.4; }\n  }\n  .finance-payment-status { font-size: 10px; color: #8d7b53; &.paid { color: #287b5f; } &.cancelled { color: #8b92a0; } }\n  .finance-payment-right { flex: 0 1 auto; max-width: 45%; display: grid; justify-items: end; gap: 4px;\n    > b { font-size: 14px; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; text-align: right; }\n  }\n  .finance-payment-actions { display: flex; gap: 2px; .finance-icon-button { border: none; } }\n  .finance-payment-menu { position: relative;\n    > summary { width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; list-style: none; cursor: pointer; color: #78849a; border-radius: 10px; &::-webkit-details-marker { display: none; } }\n    > div { position: absolute; right: 0; top: 44px; z-index: 8; padding: 5px; min-width: 205px; border: 1px solid #e1e6ef; border-radius: 11px; background: #fff; box-shadow: 0 6px 20px #23213712;\n      button { min-height: 44px; width: 100%; padding: 8px 10px; border: none; border-radius: 7px; font-size: 13px; color: #a71b34; background: #fff3f5; }\n    }\n  }\n  .finance-details {\n    > summary { display: flex; align-items: center; justify-content: space-between; gap: 8px; min-height: 44px; list-style: none; font-size: 13px; cursor: pointer; &::-webkit-details-marker { display: none; } svg { width: 16px; height: 16px; flex-shrink: 0; color: #78849a; } }\n    &[open] > summary svg { transform: rotate(180deg); }\n  }\n  .finance-card.finance-details { padding-block: 0; }\n  .finance-files { summary { min-height: 44px; display: flex; align-items: center; cursor: pointer; font-size: 11px; color: #78849a; } a { display: flex; align-items: center; min-height: 44px; font-size: 12px; color: #65718c; } }\n  .finance-cash-table { width: 100%; table-layout: fixed; border-collapse: collapse; margin-bottom: 8px; font-size: 12px;\n    th, td { padding: 9px 5px; text-align: right; border-top: 1px solid #edf0f5; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }\n    th { font-size: 10px; color: #78849a; font-weight: 500; } th:first-child, td:first-child { width: 44px; padding-left: 0; text-align: left; }\n  }\n  .finance-method p { font-size: 12px; color: #78849a; line-height: 1.5; }\n  .finance-related { display: flex; gap: 16px; a { display: inline-flex; align-items: center; min-height: 44px; font-size: 12px; color: #78849a; text-decoration: none; } }\n  .finance-lesson { border: 1px solid #dce4fa; border-radius: 14px; padding: 12px; margin-bottom: 12px; background: #f0f4ff; color: #374463;\n    h2 { margin: 8px 0 5px; font-size: 15px; }\n    > p { margin: 0; font-size: 12px; line-height: 1.5; }\n    .finance-lesson-safety { margin: 5px 0 0; font-size: 11px; color: #68799a; }\n    progress { display: block; appearance: none; width: 100%; height: 4px; margin-top: 10px; border: 0; border-radius: 4px; background: #dce4f8; &::-webkit-progress-bar { background: #dce4f8; border-radius: 4px; } &::-webkit-progress-value { background: #7d8ebc; border-radius: 4px; } &::-moz-progress-bar { background: #7d8ebc; border-radius: 4px; } }\n  }\n  .finance-lesson-meta { display: flex; align-items: center; justify-content: space-between; gap: 8px; font-size: 11px; > span { font-weight: 650; } small { color: #68799a; font-size: 11px; } }\n  .finance-lesson-actions { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; button { flex: 1 1 auto; font-size: 12px; padding-inline: 10px; } }\n  .business-error { margin: 0 0 10px; font-size: 13px; padding: 12px; button { min-height: 44px; padding: 8px 12px; margin-left: 8px; border: none; border-radius: 10px; background: #fff; font-size: 13px; color: #a71b34; } }\n  @media (max-width: 650px) {\n    & { padding: 10px 10px 24px; }\n    .finance-card { padding-inline: 12px; }\n    .finance-tabs button { font-size: 12px; }\n    .finance-profit-value > strong { font-size: 29px; }\n    .finance-primary-metrics strong { font-size: 18px; }\n    .finance-secondary-metrics { gap: 8px; }\n    .finance-add-actions { gap: 6px; button { font-size: 12px; padding-inline: 8px; } }\n    .finance-form { padding: 10px; }\n    .finance-form fieldset { gap: 8px; }\n  }\n}\n.lkfr-app .business-page.finance-page { max-width: 960px; margin-inline: auto; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
